export const computeRoute = (
  route = "",
  variables: Record<string, string | number | boolean> = {},
) => {
  return Object.entries(variables).reduce(
    (acc: string, [key, value]) => acc.replaceAll(`:${key}`, value as any),
    route,
  )
}
